
import { DataImporter } from "@/components/DataImporter";
import { CropCategoriesByCountry } from "@/components/CropCategoriesByCountry";
import { CommunitiesImporter } from "@/components/CommunitiesImporter";
import { ClimateZonesImporter } from "@/components/ClimateZonesImporter";
import { USDAZoneImporter } from "@/components/USDAZoneImporter";
import { GrowingZoneFilter } from "@/components/GrowingZoneFilter";
import { GrantsImporter } from "@/components/admin/GrantsImporter";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ArrowLeft, Upload, Globe, MapPin, TreePine, DollarSign } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ImportData = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <div className="mb-4">
          <Button onClick={handleBack} variant="outline" size="sm">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Button>
        </div>
        
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Data Management
          </h1>
          <p className="text-gray-600">
            Import crop data, manage categories by country, and configure geographic zones
          </p>
        </div>
        
        <Tabs defaultValue="crop-data" className="w-full">
          <TabsList className="grid w-full grid-cols-5">
            <TabsTrigger value="crop-data" className="flex items-center gap-2">
              <Upload className="h-4 w-4" />
              Crop Data
            </TabsTrigger>
            <TabsTrigger value="browse-crops" className="flex items-center gap-2">
              <Globe className="h-4 w-4" />
              Browse by Country
            </TabsTrigger>
            <TabsTrigger value="communities" className="flex items-center gap-2">
              <MapPin className="h-4 w-4" />
              Communities
            </TabsTrigger>
            <TabsTrigger value="zones" className="flex items-center gap-2">
              <TreePine className="h-4 w-4" />
              Growing Zones
            </TabsTrigger>
            <TabsTrigger value="grants" className="flex items-center gap-2">
              <DollarSign className="h-4 w-4" />
              Grants
            </TabsTrigger>
          </TabsList>

          <TabsContent value="crop-data" className="space-y-6">
            <div className="flex justify-center">
              <DataImporter />
            </div>
          </TabsContent>

          <TabsContent value="browse-crops" className="space-y-6">
            <CropCategoriesByCountry />
          </TabsContent>

          <TabsContent value="communities" className="space-y-6">
            <div className="flex justify-center">
              <CommunitiesImporter />
            </div>
          </TabsContent>

          <TabsContent value="zones" className="space-y-6">
            <div className="space-y-8">
              <div className="flex justify-center">
                <ClimateZonesImporter />
              </div>

              <div className="flex justify-center">
                <USDAZoneImporter />
              </div>

              {/* Growing Zone Filter Demo */}
              <div className="flex justify-center">
                <div className="space-y-4 w-full max-w-2xl">
                  <h2 className="text-2xl font-bold text-center">Growing Zone Filter Demo</h2>
                  <GrowingZoneFilter 
                    onFilterChange={(filters) => {
                      console.log('Filter changed:', filters);
                    }}
                  />
                </div>
              </div>
            </div>
          </TabsContent>

          <TabsContent value="grants" className="space-y-6">
            <div className="flex justify-center">
              <GrantsImporter />
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default ImportData;
